<script>
import Swal from 'sweetalert2';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import rentalCustomerService from '@/api/rentalCustomerService.js';
import systemService from '@/api/systemService.js';

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      selected: null,
      licenseOptions: [
        { value: null, text: 'Please select an option' },
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
      licenseTypeOptions: [
        { value: null, text: 'Please select an option' },
        { value: 'A', text: 'A' },
        { value: 'B', text: 'B' },
        { value: 'B2', text: 'B2' },
        { value: 'Other', text: 'Other' },
      ],
      rentalPurposeOptions: [
        { value: null, text: 'Please select an option' },
        { value: 'Work (Grab, etc)', text: 'Work (Grab, etc)' },
        { value: 'Commuting', text: 'Commuting' },
        { value: 'Leisure', text: 'Leisure' },
        { value: 'Other', text: 'Other' },
      ],
      rentalLengthOptions: [
        { value: null, text: 'Please select an option' },
        { value: 'Days', text: 'Days' },
        { value: 'Months', text: 'Months' },
      ],
      yesNoOptions: [
        { value: null, text: 'Please select an option' },
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_BACKEND_URL || 'https://backend.api.myezicash.app'}/upload`,
        thumbnailWidth: 150,
        maxFilesize: 10,
      },
      existingFiles: [],
      uploadedFiles: [],
      
      // Form fields
      name: null,
      ic_no: null,
      residential_address: null,
      has_license: null,
      license_type: null,
      rental_purpose: null,
      rental_length: null,
      criminal_record: null,
      approved_for_rental: null,
      deposit_paid: null,
      deposit_amount: null,
      customer_account_no: null,
      
      // Document fields
      ic_document_provided: false,
      utility_bill_provided: false,
      id_document_provided: false,
      other_documents_provided: false,
    };
  },
  props: {
    form_data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    edit_permission: {
      type: Boolean,
      default: false,
    },
    getData: {
      type: Function,
      required: true
    }
  },
  methods: {
    formValidation(e, type = 'text') {
      const emailRegex = /\S+@\S+\.\S+/;

      switch (type) {
        case 'email':
          return e !== null && e !== undefined && e !== '' && emailRegex.test(e);
        default:
          return e !== null && e !== undefined && e !== '';
      }
    },
    submitHandler() {
      this.$refs.customerInfoSubmit.click()
    },
    fileName(url) {
      const split_url = url.split('/');
      return split_url[split_url.length - 1];
    },
    onFileUploadSuccess(file, response) {
      const {
        files: {
          file: { url }
        }
      } = response;
      this.uploadedFiles.push(url);
    },
    async detectData() {
      if (this.form_data && this.form_data.id) {
        const {
          name,
          ic_no,
          residential_address,
          has_license,
          license_type,
          rental_purpose,
          rental_length,
          criminal_record,
          approved_for_rental,
          deposit_paid,
          deposit_amount,
          customer_account_no,
          ic_document_provided,
          utility_bill_provided,
          id_document_provided,
          other_documents_provided,
          files
        } = this.form_data;

        this.name = name;
        this.ic_no = ic_no;
        this.residential_address = residential_address;
        this.has_license = has_license;
        this.license_type = license_type;
        this.rental_purpose = rental_purpose;
        this.rental_length = rental_length;
        this.criminal_record = criminal_record;
        this.approved_for_rental = approved_for_rental;
        this.deposit_paid = deposit_paid;
        this.deposit_amount = deposit_amount;
        this.customer_account_no = customer_account_no;
        this.ic_document_provided = ic_document_provided;
        this.utility_bill_provided = utility_bill_provided;
        this.id_document_provided = id_document_provided;
        this.other_documents_provided = other_documents_provided;
        this.existingFiles = files || [];
      }
    },
    deleteFile(id) {
      Swal.fire({
        title: 'Confirm',
        text: 'Are you sure you want to delete this file?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.value) {
          const response = await systemService.deleteFile(id);
          if (response) {
            Swal.fire({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              icon: 'success',
            });
            this.$emit('refresh')
            this.assignData()
          }
        }
      })
    },
    convertEmptyStringToNull(obj) {
      for (const key in obj) {
        if (obj[key] === '') {
          obj[key] = null;
        }
      }
      return obj;
    },
    saveRentalCustomer() {
      var body = {
        name: this.name,
        ic_no: this.ic_no,
        residential_address: this.residential_address,
        has_license: this.has_license,
        license_type: this.license_type,
        rental_purpose: this.rental_purpose,
        rental_length: this.rental_length,
        criminal_record: this.criminal_record,
        approved_for_rental: this.approved_for_rental,
        deposit_paid: this.deposit_paid,
        deposit_amount: this.deposit_amount,
        customer_account_no: this.customer_account_no,
        ic_document_provided: this.ic_document_provided,
        utility_bill_provided: this.utility_bill_provided,
        id_document_provided: this.id_document_provided,
        other_documents_provided: this.other_documents_provided,
      }
    
      body = this.convertEmptyStringToNull(body)

      Swal.fire({
        title: 'Confirm',
        text: 'Are you sure you want to submit this rental customer information?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.value) {
          let response;
          if (this.form_data && this.form_data.id) {
            response = await rentalCustomerService.update(this.form_data.id, body);
          } else {
            response = await rentalCustomerService.post(body);
          }
          
          if (response) {
            // Handle uploaded files
            if (this.uploadedFiles.length > 0) {
              for (const file of this.uploadedFiles) {
                await rentalCustomerService.addDocument(response.data.id, {
                  document_type: 'Other',
                  file_path: file,
                  file_name: this.fileName(file)
                });
              }
            }
            
            Swal.fire({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              icon: 'success',
            });

            if (!this.form_data || !this.form_data.id) {
              this.$router.push({
                name: 'rental-id',
                query: {
                  id: response.data.id,
                }
              });

              setTimeout(() => {
                location.reload()
              }, 100);
            } else {
              this.$emit('refresh');
            }
          }
        }
      })
    },
    assignData() {
      setTimeout(() => {
        this.detectData();
      }, 1000);
    },
    onSubmit(e) {
      e.preventDefault();
      this.saveRentalCustomer()
    }
  },
  mounted() {
    this.assignData();
  }
};
</script>

<template>
  <b-form @submit="onSubmit">
    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button class="accordion-button" variant="primary">Customer Information</b-button>
        </b-card-header>
        <b-collapse :visible="true">
          <b-card-body>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Name" label-for="name" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="name" id="name" type="text" :state="formValidation(name)" required></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="IC Number" label-for="ic_no" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="ic_no" id="ic_no" type="text" :state="formValidation(ic_no)" required></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group label="Current Residential Address" label-for="residential_address" class="mb-3">
                  <b-form-textarea :disabled="edit_permission" v-model="residential_address" id="residential_address" rows="3" :state="formValidation(residential_address)" required></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="License" label-for="has_license" class="mb-3">
                  <b-form-select
                    id="has_license"
                    style="padding: 0.47rem 0.75rem; font-size: 0.9rem; width: 100%; height: 100%;"
                    :disabled="edit_permission" 
                    v-model="has_license"
                    :options="licenseOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Type of License" label-for="license_type" class="mb-3">
                  <b-form-select
                    id="license_type"
                    style="padding: 0.47rem 0.75rem; font-size: 0.9rem; width: 100%; height: 100%;"
                    :disabled="edit_permission || !has_license" 
                    v-model="license_type"
                    :options="licenseTypeOptions"
                    :required="has_license"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Purpose of Rental" label-for="rental_purpose" class="mb-3">
                  <b-form-select
                    id="rental_purpose"
                    style="padding: 0.47rem 0.75rem; font-size: 0.9rem; width: 100%; height: 100%;"
                    :disabled="edit_permission" 
                    v-model="rental_purpose"
                    :options="rentalPurposeOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Length of Rental" label-for="rental_length" class="mb-3">
                  <b-form-select
                    id="rental_length"
                    style="padding: 0.47rem 0.75rem; font-size: 0.9rem; width: 100%; height: 100%;"
                    :disabled="edit_permission" 
                    v-model="rental_length"
                    :options="rentalLengthOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Any Criminal Record" label-for="criminal_record" class="mb-3">
                  <b-form-select
                    id="criminal_record"
                    style="padding: 0.47rem 0.75rem; font-size: 0.9rem; width: 100%; height: 100%;"
                    :disabled="edit_permission" 
                    v-model="criminal_record"
                    :options="yesNoOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Approved for Rental" label-for="approved_for_rental" class="mb-3">
                  <b-form-select
                    id="approved_for_rental"
                    style="padding: 0.47rem 0.75rem; font-size: 0.9rem; width: 100%; height: 100%;"
                    :disabled="edit_permission" 
                    v-model="approved_for_rental"
                    :options="yesNoOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Deposit Paid" label-for="deposit_paid" class="mb-3">
                  <b-form-select
                    id="deposit_paid"
                    style="padding: 0.47rem 0.75rem; font-size: 0.9rem; width: 100%; height: 100%;"
                    :disabled="edit_permission" 
                    v-model="deposit_paid"
                    :options="yesNoOptions"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Deposit Amount" label-for="deposit_amount" class="mb-3">
                  <b-form-input :disabled="edit_permission || !deposit_paid" v-model="deposit_amount" id="deposit_amount" type="number" :state="deposit_paid ? formValidation(deposit_amount) : null" :required="deposit_paid"></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group label="Customer A/C No." label-for="customer_account_no" class="mb-3">
                  <b-form-input :disabled="edit_permission" v-model="customer_account_no" id="customer_account_no" type="text"></b-form-input>
                </b-form-group>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button class="accordion-button" variant="primary">Documents</b-button>
        </b-card-header>
        <b-collapse :visible="true">
          <b-card-body>
            <div class="row mb-3">
              <div class="col-md-3">
                <b-form-group label="IC Document Provided" label-for="ic_document_provided" class="mb-3">
                  <b-form-checkbox
                    id="ic_document_provided"
                    v-model="ic_document_provided"
                    :disabled="edit_permission"
                    name="ic_document_provided"
                    value="true"
                    unchecked-value="false"
                  >
                    Yes
                  </b-form-checkbox>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Utility Bill Provided" label-for="utility_bill_provided" class="mb-3">
                  <b-form-checkbox
                    id="utility_bill_provided"
                    v-model="utility_bill_provided"
                    :disabled="edit_permission"
                    name="utility_bill_provided"
                    value="true"
                    unchecked-value="false"
                  >
                    Yes
                  </b-form-checkbox>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="ID Document Provided" label-for="id_document_provided" class="mb-3">
                  <b-form-checkbox
                    id="id_document_provided"
                    v-model="id_document_provided"
                    :disabled="edit_permission"
                    name="id_document_provided"
                    value="true"
                    unchecked-value="false"
                  >
                    Yes
                  </b-form-checkbox>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Other Documents Provided" label-for="other_documents_provided" class="mb-3">
                  <b-form-checkbox
                    id="other_documents_provided"
                    v-model="other_documents_provided"
                    :disabled="edit_permission"
                    name="other_documents_provided"
                    value="true"
                    unchecked-value="false"
                  >
                    Yes
                  </b-form-checkbox>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 card"
                style="padding: 0.5rem">
                <vue-dropzone v-if="!edit_permission"
                  id="dropzone"
                  ref="myVueDropzone"
                  :use-custom-slot="true"
                  :options="dropzoneOptions"
                  @vdropzone-success="onFileUploadSuccess">
                  <div class="dropzone-custom-content">
                    <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                    <h4>Drop files here or click to upload.</h4>
                  </div>
                </vue-dropzone>

                <div v-for="(file, index) in existingFiles" :key="index">
                  <div>
                    <span v-if="file.label" class="badge bg-success">{{ file.label }}</span>
                    <span v-else class="badge bg-danger">Others</span> &nbsp;
                    <a :href="file.url" target="_blank">{{ fileName(file.url) }}</a>
                    <a v-if="!edit_permission" @click="deleteFile(file.id)" href="#" class="px-2 text-danger"><i
                        class="uil uil-trash-alt font-size-18"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <br>
    <b-button v-if="!edit_permission" ref="customerInfoSubmit" type="submit" variant="primary" >
      {{ form_data?.id ? 'Update Customer Information' : 'Save Customer Information' }}
    </b-button>
  </b-form>
</template>

<style lang="scss"></style>
